import { Component, Input } from '@angular/core';

@Component({
  selector: 'sigecom-list-info',
  template: `
    <p class="text-sigecom-gray min-w-20 line-clamp-2 text-sm overflow-ellipsis">
      <span *ngIf="info != ''" class="font-bold">{{ info }}: </span>
      <span class="font-medium">{{ value }}</span>
    </p>
  `,
  styles: [
  ]
})
export class ListInfoComponent {
  @Input() info: string  = '';
  @Input() value: string = '';
}
